import { createContext, useContext } from 'react';
import { AdminPermissions } from '../graphql/types.generated';

interface Props {
  firstName: string;
  lastName: string;
  id: string;
  setUser: (userFirstName: string, userLastName: string, id: string, permissions: AdminPermissions) => void;
  unsetUser: () => void;
  permissions: AdminPermissions;
}

const UserContext = createContext<Props>({
  firstName: '',
  lastName: '',
  id: '',
  setUser: () => {},
  unsetUser: () => {},
  permissions: {}
});

const useUserDetails = () => useContext(UserContext);

export { useUserDetails };

export default UserContext;
